import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ScriptHistoryControls({ currentScriptNumber, scriptCount, goToPreviousScript, goToNextScript, disabled = false }) {
  if (scriptCount < 2) return null;

  const buttonClass = "flex items-center text-gray-500 transition-colors hover:text-gray-700 disabled:cursor-not-allowed disabled:opacity-40 dark:text-gray-400 dark:hover:text-gray-200";

  return (
    <div role="group" aria-label="Script history" className="flex shrink-0 items-center gap-2">
      <div aria-hidden="true" className="mr-2 hidden h-6 w-px bg-gray-200 dark:bg-gray-700 sm:block" />
      <span role="status" className="whitespace-nowrap text-sm tabular-nums text-gray-500 dark:text-gray-400">
        Script {currentScriptNumber}/{scriptCount}
      </span>
      <button type="button" onClick={goToPreviousScript} disabled={disabled || currentScriptNumber <= 1} aria-label="Previous script" className={buttonClass}>
        <ChevronLeft aria-hidden="true" className="h-4 w-4" />
        <span className="text-sm">Previous</span>
      </button>
      <button type="button" onClick={goToNextScript} disabled={disabled || currentScriptNumber >= scriptCount} aria-label="Next script" className={buttonClass}>
        <span className="text-sm">Next</span>
        <ChevronRight aria-hidden="true" className="h-4 w-4" />
      </button>
    </div>
  );
}
